<template>
  <div>
    <!-- dekstop -->
    <div class="d-none d-sm-block">
      <b-row class="center-base between">
        <b-col cols="4">
          <span style="font-size: 1.5em; font-weight: 700; color: #233c7c;">
            Service Details
          </span>
        </b-col>
        <b-col cols="2" class="text-right">
          <span class="editable-text" @click="changeService"  v-b-tooltip.hover.bottom title="edit service">
            <font-awesome-icon icon="pencil-alt" style="font-size: 1.2em; font-weight: 500; color: #f27137;" />
          </span>
        </b-col>
      </b-row>

      <hr style="border-top: 2px solid #dddddd;">

      <b-row class="mt-4">
        <b-col cols="3">
          <b-img
            :src="require(`@/assets/icon/services/${ name.toLowerCase() }.png`)"
            fluid
          />
        </b-col>
        <b-col>
          <h4>
            {{ duration }} hours.
            <span v-if="min_pax && max_pax">
              {{ min_pax }} - {{ max_pax }} Passenger.
            </span>
          </h4>
          <ul v-for="(description, index) in description" :key="index" style="margin-bottom: 0px !important;">
            <li>{{ description }}</li>
          </ul>
        </b-col>
      </b-row>

      <!-- more service -->
      <!-- <b-row class="mt-5" v-if="more_service_options.length">
        <b-col>
          <span style="font-size: 1.4em; font-weight: 500; color: #233c7c;">
            Add more service for more convenience!
          </span>
        </b-col>
      </b-row> -->

      <!-- <b-row class="mt-3" v-for="(x, i) in more_service_options" :key="i">
        <b-col cols="8" offset="1" class="center-base vertical">
          <b-img
            :src="require(`@/assets/icon/services/${x.logo}.png`)"
            fluid
            style="max-width: 4rem;"
          />
          <div class="m-2">
            <span style="font-size: 16px;">{{ x.name }} - </span>
            <span style="font-size: 18px;">{{ x.currency }} {{ x.price }}</span>
            <p style="font-size: 12px;">{{ x.description }}</p>
          </div>
        </b-col>

        <b-col cols="1" class="center-base all">
          <font-awesome-icon icon="plus" style="color: #f27137; font-size: 22px; font-weight: 600;" />
        </b-col>
      </b-row> -->
    </div>

    <!-- mobile -->
    <div class="d-block d-sm-none">
      <b-row class="center-base between">
        <b-col cols="6">
          <span style="font-size: 1.2em; font-weight: 700; color: #233c7c;">
            Service Details
          </span>
        </b-col>
        <b-col cols="2" class="text-right">
          <span class="editable-text" @click="changeService"  v-b-tooltip.hover.bottom title="edit service">
            <font-awesome-icon icon="pencil-alt" style="font-size: 1em; font-weight: 500; color: #f27137;" />
          </span>
        </b-col>
      </b-row>

      <hr style="border-top: 2px solid #dddddd;">

      <b-row class="mt-4 justify-content-center">
        <b-col cols="6">
          <b-img
            :src="require(`@/assets/icon/services/${ name.toLowerCase() }.png`)"
            fluid
          />
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col>
          <h6>
            {{ duration }} hours.
            <span v-if="min_pax && max_pax">
              {{ min_pax }} - {{ max_pax }} Passenger.
            </span>
          </h6>
          <ul v-for="(description, index) in description" :key="index" style="margin-bottom: 0px !important;">
            <li>{{ description }}</li>
          </ul>
        </b-col>
      </b-row>

      <!-- more service -->
      <!-- <b-row class="mt-5" v-if="more_service_options.length">
        <b-col>
          <span style="font-size: 1em; font-weight: 500; color: #233c7c;">
            Add more service for more convenience!
          </span>
        </b-col>
      </b-row> -->

      <!-- <b-row class="mt-3" v-for="(x, i) in more_service_options" :key="i">
        <b-col cols="8" offset="1" class="center-base vertical">
          <b-img
            :src="require(`@/assets/icon/services/${x.logo}.png`)"
            fluid
            style="max-width: 4rem;"
          />
          <div class="m-2">
            <span style="font-size: 16px;">{{ x.name }} - </span>
            <span style="font-size: 18px;">{{ x.currency }} {{ x.price }}</span>
            <p style="font-size: 12px;">{{ x.description }}</p>
          </div>
        </b-col>

        <b-col cols="1" class="center-base all">
          <font-awesome-icon icon="plus" style="color: #f27137; font-size: 22px; font-weight: 600;" />
        </b-col>
      </b-row> -->
    </div>
  </div>
</template>

<script>
// external dependencies

// custom component

// api call

export default {
  name: 'Order_ServiceDetail',
  props: ['name', 'min_pax', 'max_pax', 'duration', 'description', 'more_service_options'],
  data () {
    return {
    }
  },
  methods: {
    // PREREQUISITES
    changeService: function () {
      this.$emit('changeService')
    }
    // END PREREQUISITES

    // HTTP REQUEST
    // END HTTP REQUEST
  }
}
</script>

<style scoped>
.editable-text {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Order/ServiceDetail/ServiceDetail.vue